import { render, staticRenderFns } from "./status-badge.vue?vue&type=template&id=8e57ab34&scoped=true&"
import script from "./status-badge.vue?vue&type=script&lang=js&"
export * from "./status-badge.vue?vue&type=script&lang=js&"
import style0 from "./status-badge.vue?vue&type=style&index=0&id=8e57ab34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e57ab34",
  null
  
)

export default component.exports